import ReactGA4 from 'react-ga4';
import { analytics } from '../../firebase';

export const SendAnalytics = (category) => {
  const eventTracker = (payload) => {
    const { action, label, name } = payload;

    const options = {
      category,
      action,
      label,
    };

    // console.info('===> [ANALYTICS]', { category, ...payload })

    ReactGA4.event(options);
    analytics.logEvent(name, label);
  };
  return eventTracker;
};

export const GenerateLabel = ({
  label = '',
  users = 'free, VIP',
  faq = '',
  event = '',
  promo = '',
  content = '',
  question = '',
  strategy = '',
  action = '',
  duration = '',
  emiten = '',
  signal = '',
  tab = '',
  type = '',
  title = '',
  tickerType = '',
  popUpUpgrade = '',
  banner = '',
  posted = '',
  category = '',
  userType = '',
  contentType = '',
  contentTitle = '',
  contentCategory = '',
  loginMethod = '',
  registerMethod = '',
  platform = '',
  removeUser = false,
}) => {
  const userData = GetVuexUserData()
  const status = userData?.status?.length ? userData?.status?.toLowerCase() : null
  const userStatus = status ?? 'non user'

  const labels = [
    label,
    question?.length ? `{question: ${question}}` : '',
    registerMethod?.length ? `{register method: ${registerMethod}}` : '',
    loginMethod?.length ? `{login method: ${loginMethod}}` : '',
    tickerType?.length ? `{type-ticker: ${tickerType}}` : '',
    popUpUpgrade?.length ? `{pop up: ${popUpUpgrade}}` : '',
    userType?.length ? `{user type: ${userType}}` : '',
    posted?.length ? `{posted at: ${posted}}` : '',
    faq?.length ? `{faq: ${faq}}` : '',
    banner?.length ? `{banner: ${banner}}` : '',
    event?.length ? `{event: ${event}}` : '',
    promo?.length ? `{promo: ${promo}}` : '',
    action?.length ? `{action: ${action}}` : '',
    strategy?.length ? `{strategy: ${strategy}}` : '',
    signal?.length ? `{signal type: ${signal}}` : '',
    emiten?.length ? `{emiten: ${emiten}}` : '',
    duration?.length ? `{filter duration: ${duration}}` : '',
    tab?.length ? `{tab: ${tab}}` : '',
    type?.length ? `{type: ${type}}` : '',
    category?.length ? `{category: ${category}}` : '',
    title?.length ? `{title: ${title}}` : '',
    content?.length ? `{content: ${content}}` : '',
    contentType?.length ? `{content type: ${contentType}}` : '',
    contentCategory?.length ? `{content category: ${contentCategory}}` : '',
    contentTitle?.length ? `{content title: ${contentTitle}}` : '',
    platform?.length ? `{platform: ${platform}}` : '',
    !removeUser ? `{users: ${userStatus}}` : '',
  ].filter((item) => !!item?.length);

  return labels.join(' - ');
};

const GetVuex = () => {
  const vuex = localStorage.getItem('vuex')
  const vuexParse = JSON.parse(vuex)
  return vuexParse
}

export const GetVuexUserData = () => {
  const localData = GetVuex()
  const userData = localData?.membershipData?.id ? localData?.membershipData : null
  return userData
}
